import { setElementInnerHTML } from "../lib/utils.js"
import { fetchJson } from "../lib/fetchJson.js"

class FFNewsletter {

  DOM: {
    form: HTMLElement | null
    email: HTMLInputElement | null
    honorific: HTMLInputElement | null
  }

	constructor(){
		this.DOM = {
			form: document.querySelector('.js-newsletterForm'),
			email: document.querySelector('.js-newsletterForm input[name="EMAIL"]'),
			honorific: document.querySelector('.js-newsletterForm input[name="honorific"]'),
		}
		this.events();
	}

	events(){
		this.DOM.form?.addEventListener( 'submit', this.formSubmit.bind(this) );
	}

	formSubmit(e: SubmitEvent){
		e.preventDefault();
		
		const data = {
			email: this.DOM.email?.value,
			honorific: this.DOM.honorific?.value,
		}
		fetchJson( "https://nw3s7sees2.execute-api.us-west-2.amazonaws.com/Prod/subscribe", {
			method: "POST",
			body: JSON.stringify(data),
			headers: {
				"Content-type": "application/json; charset=UTF-8"
			}
		})
			.then( this.submissionSuccess.bind(this) )
			.catch( this.submissionError.bind(this) );
	}

	submissionSuccess(){
		setElementInnerHTML( this.DOM.form, '<p class="success">Nice! You&rsquo;re all set.</p>')
	}

	submissionError(){
		setElementInnerHTML( this.DOM.form, '<p class="error">Something went wrong. Please try again.</p>')
	}
}
new FFNewsletter();